import { render } from "./Register.vue?vue&type=template&id=2d8d4fb6&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "@/assets/css/Header.css?vue&type=style&index=0&id=2d8d4fb6&scoped=true&lang=css&external"
import "@/assets/css/Register.css?vue&type=style&index=1&id=2d8d4fb6&scoped=true&lang=css&external"
import "@/assets/css/Footer.css?vue&type=style&index=2&id=2d8d4fb6&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d8d4fb6"]])

export default __exports__